// service
import { getEmailsInEvent } from "../../../utils/services/imports";
import { getFlight } from "../../../utils/services/flight";
// moment
import moment from "moment/moment";

export const excelColumnsPtBrDelete = {
  NomeParticipante: "name",
  IdVoo: "id",
};

export const excelColumnsPtBrUpdate = {
  IdVoo: "id",
  Participante: "login",
  "Data Embarque": "boardingdate",
  "Hora Embarque": "boardingtill",
  "Data Chegada": "arrivaldate",
  "Hora Chegada": "arrivaltime",
  Companhia: "company",
  Origem: "origin",
  Destino: "destination",
  Localizador: "locator",
  "E-Ticket": "eticket",
  "Numero do Voo": "flightnumber",
  Terminal: "terminal",
  Assento: "seat",
  "Grupo De Embarque": "boardinggroup",
  "Informacoes Extras": "extrainformation",
};

export const excelColumnsPtBr = {
  Participante: "login",
  "Data Embarque": "boardingdate",
  "Hora Embarque": "boardingtill",
  "Data Chegada": "arrivaldate",
  "Hora Chegada": "arrivaltime",
  Companhia: "company",
  Origem: "origin",
  Destino: "destination",
  Localizador: "locator",
  "E-Ticket": "eticket",
  "Numero do Voo": "flightnumber",
  Terminal: "terminal",
  Assento: "seat",
  "Grupo De Embarque": "boardinggroup",
  "Informacoes Extras": "extrainformation",
};

// const regexDate = /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/;
// const regexHour = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
const regexEmail =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function formatDate(date) {
  try {
    const dateSplit = date.split("/");

    if (!dateSplit[0] || !dateSplit[1] || !dateSplit[2]) return undefined;

    const dateFormated = `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`;

    if (new Date(dateFormated)) {
      return dateFormated;
    } else return undefined;
  } catch (error) {
    return undefined;
  }
}

function formatTime(time) {
  try {
    if (/^\d{2}:\d{2}$/.test(time) && moment(time, "HH:mm", true).isValid()) {
      return time;
    } else return undefined;
  } catch (error) {
    return undefined;
  }
}

function emailValidate(email) {
  try {
    const emailValid = regexEmail.test(email);
    return emailValid ? email : undefined;
  } catch (error) {
    return undefined;
  }
}

export function allExcelColumns(row, index) {
  const formatedRow = {
    index,
    login: emailValidate(row.login),
    boardingdate: formatDate(row.boardingdate),
    boardingtill: formatTime(row.boardingtill),
    arrivaldate: formatDate(row.arrivaldate),
    arrivaltime: formatTime(row.arrivaltime),
    company: row.company,
    origin: row.origin,
    destination: row.destination,
    locator: row.locator ? row.locator : "",
    eticket: row.eticket ? row.eticket : "",
    flightnumber: row.flightnumber ? row.flightnumber : "",
    terminal: row.terminal ? row.terminal : "",
    seat: row.seat ? row.seat : "",
    boardinggroup: row.boardinggroup ? row.boardinggroup : "",
    extrainformation: row.extrainformation ? row.extrainformation : "",
  };

  return formatedRow;
}

export function findRowsWithError(validRows) {
  const rowsWithError = validRows.filter(
    (row) =>
      Object.values(row).filter((value) => value === undefined).length > 0
  );
  return rowsWithError;
}

export async function getUnregisteredEmails(file, jwt, eventId) {
  const limit = 99999999;
  const dataInDB = [];
  let numberOfRequisitions = 1;
  file = file.map((e) => {
    return {
      ...e,
      login: e.login.toLowerCase(),
    };
  });
  for (let i = 1; i <= numberOfRequisitions; i += 1) {
    const emails = await getEmailsInEvent({
      jwt,
      eventId,
      offset: i,
      limit,
    });

    if (i === 1) {
      numberOfRequisitions = Math.ceil(emails.count / limit);
    }
    dataInDB.push(emails);
    setTimeout(() => {}, 500);
  }

  const emailsInDB = dataInDB.map((email) => email.data).flat();

  const unregisteredEmails = file
    .filter(({ login: email }) => !emailsInDB.includes(email))
    .map((row) => ({
      ...row,
      login: undefined,
    }));

  return unregisteredEmails;
}

export function allExcelColumnsUpdate(row, index) {
  const formatedRow = {
    index,
    id: row.id,
    login: emailValidate(row.login),
    boardingdate: formatDate(row.boardingdate),
    boardingtill: formatTime(row.boardingtill),
    arrivaldate: formatDate(row.arrivaldate),
    arrivaltime: formatTime(row.arrivaltime),
    company: row.company,
    origin: row.origin,
    destination: row.destination,
    locator: row.locator ? row.locator : "",
    eticket: row.eticket ? row.eticket : "",
    flightnumber: row.flightnumber ? row.flightnumber : "",
    terminal: row.terminal ? row.terminal : "",
    seat: row.seat ? row.seat : "",
    boardinggroup: row.boardinggroup ? row.boardinggroup : "",
    extrainformation: row.extrainformation ? row.extrainformation : "",
  };

  return formatedRow;
}

export async function getValidFlights(flights, idEvent, isUpdate) {
  try {
    const res = await getFlight({
      idEvent,
      offset: 1,
      limit: 10000,
      search: "",
      columnSearch: "login",
    });

    const listAllFlights =
      res.findOneFlightData.count > 0 ? res.findOneFlightData.data : [];

    var flightsNotFounds = [];

    for (const flight of flights) {
      const search = listAllFlights.find((e) => e.id === flight.id);

      if (!search) {
        flightsNotFounds.push({
          ...flight,
          id: undefined,
        });
      } else if (search && isUpdate && search.login.email !== flight.login) {
        flightsNotFounds.push({
          ...flight,
          login: undefined,
        });
      } else {
      }
    }

    return flightsNotFounds;
  } catch (error) {
    // console.log("get flights error", error);
    return [];
  }
}

export function allExcelColumnsDelete(row, index) {
  const formatedRow = {
    index,
    id: row.id,
    name: row.name,
  };

  return formatedRow;
}
